import { i18n } from 'i18n';
import { memo } from 'react';
import type {
  CellThreatGroupProps,
  HeaderThreatGroupProps,
  ThreatGroupUnion,
} from 'src/features/edr/threat/threat.types';
import { constants } from '../../../../common';
import HeaderWithTooltip from '../../../../common/components/ThreatListTable/TableHeaderWithTooltip';
import ThreatListStatusSummaryBadges from '../../../ThreatListStatusSummaryBadges';

export type StatusHeaderProps = {
  text: string;
  isFileDetectionType: boolean;
};

export type StatusCellProps = {
  row: ThreatGroupUnion;
  isFileDetectionType: boolean;
};

export const StatusHeader = ({
  text,
  isFileDetectionType,
}: StatusHeaderProps) => {
  const tooltip = isFileDetectionType
    ? i18n.t('Not quarantined, Quarantined, Resolved, Released')
    : i18n.t('Detected, Blocked, Informational');

  return <HeaderWithTooltip text={text} tooltip={tooltip} />;
};

export const StatusCell = memo(
  ({ row, isFileDetectionType }: StatusCellProps) => {
    const isMalicious =
      row.classification === constants.THREAT_BEHAVIORAL_CLASSIFICATION.MAL;

    return (
      <ThreatListStatusSummaryBadges
        notQuarantined={row.not_quarantined_count}
        quarantined={row.quarantined_count}
        resolved={row.resolved_count}
        released={row.released_count}
        detected={row.detected_count}
        blocked={row.blocked_count}
        informational={row.informational_count}
        isFileDetectionType={isFileDetectionType}
        isMalicious={isMalicious}
      />
    );
  },
);

export const renderStatusHeader = (
  info: HeaderThreatGroupProps<unknown>,
  isFileDetectionType: boolean,
) => {
  const text = info.column.columnDef.meta?.displayName;
  if (!text) return null;

  return <StatusHeader text={text} isFileDetectionType={isFileDetectionType} />;
};

export const renderStatusCell = (
  info: CellThreatGroupProps<unknown>,
  isFileDetectionType: boolean,
) => {
  const row = info?.row?.original;

  return <StatusCell row={row} isFileDetectionType={isFileDetectionType} />;
};
